import $ from "jquery";
const showSideMenu = (e) => {
    $(".side-menu").addClass("side-menu-visible");
    $(".side-menu-overlay").addClass("side-menu-overlay-visible");
};
const hideSideMenu = (e) => {
    e.stopPropagation();
    $(".side-menu").removeClass("side-menu-visible");
    $(".side-menu-overlay").removeClass("side-menu-overlay-visible");
};
$(document).on("click", "#side-menu-show-btn", showSideMenu);
$(document).on("click", "#side-menu-hide-btn", hideSideMenu);
